import INavigationItem from "@/apps/NavigationWidget/model/navigation-item";
import {Breakpoint} from "@/shared/models/breakpoint-type";

export interface INavigationWidgetState {
    menuOpen: boolean;
    data: any;
    loading: boolean;
    storedTree: INavigationItem[];
    bodyEle: HTMLElement;
    leftSideNavSecond: Object;
    currentBreakpoint: Breakpoint;
    labels: any;
}

export class NavigationWidgetState implements INavigationWidgetState {
    menuOpen = false;
    data: any = {};
    loading = true;
    storedTree: INavigationItem[] = [];
    bodyEle: HTMLElement = document.body;
    leftSideNavSecond = {};
    currentBreakpoint = Breakpoint.Desktop;
    labels: any = {};
}


